import { useMutation } from '@tanstack/react-query'
import { useNavigate } from '@tanstack/react-router'
import { useAuthStore } from '../store/authStore'
import { login } from '../utils/login'
import type { ApiError } from '@/types/api'

export const useLoginMutation = () => {
  const loginAction = useAuthStore((state) => state.login)
  const navigate = useNavigate()

  return useMutation({
    mutationFn: login,
    onSuccess: (data) => {
      loginAction(
        data.user,
        data.accessToken,
        data.refreshToken,
        data.expiresAt,
      )
      navigate({ to: '/' })
    },
    onError: (error: ApiError) => {
      return error
    },
  })
}
